import { TextInput, type TextInputProps } from "@prismicio/editor-ui"
import { forwardRef } from "react"

export const FieldTextInput = forwardRef<HTMLInputElement, TextInputProps>(
  function FieldTextInput(props, ref) {
    const { padding = fieldInputPadding, ...otherProps } = props

    return (
      <TextInput
        {...otherProps}
        padding={padding}
        ref={ref}
        sx={{ ...props.sx, alignSelf: "stretch" }}
      />
    )
  },
)

export const fieldInputPadding = {
  input: { inline: 4 },
  adornment: { inline: 12 },
} as const
